import Data from 'app-core/Data';
import storage from 'storage';
import _ from 'lodash';

const tabId = Data.uuid();
const initiated = Date.now();
let tabInitiated = false;

let tabsPropValue = null;

let tabsProp = () => {
	if (!tabsPropValue?.value?.tabs) {
		tabsPropValue = storage.prop('tabs-manager', 'root', {
			tabs: [],
			focusedTab: tabId
		});
	}

	if (typeof(tabsPropValue.value) !== 'object') {
		tabsPropValue.value = {
			tabs: [],
			focusedTab: tabId
		};
	}

	return tabsPropValue;
}

let instance = {};

if (__DEBUG__) {
	window.tabsManagerInstance = instance;
	window.tabsManagerProp = tabsProp();
	window.tabId = tabId;
}

function currentTab() {
	return instance.tabs && instance.tabs.find(f => f.tabId === tabId);
}

function activeTabs() {
	tabsProp().loadData();
	return _.orderBy(instance.tabs.filter(f => Date.now() - f.lastActivity < 10000), ['initiated']);
}

function checkTab() {
	tabsProp().loadData();
	if (currentTab()) return;
	instance.tabs.push({
		tabId,
		lastActivity: Date.now(),
		initiated
	});
	instance.tabs = activeTabs();
	tabsProp().saveData();
}

function initTab() {
	if (tabInitiated) return;
	
	checkTab();
	setTimeout(checkTab, 500);
	setInterval(updateTabActivity, 5000);
	focusTab();

	window.addEventListener('unload', removeTab);
	window.addEventListener('focus', focusTab);
	document.addEventListener('visibilitychange', focusTab);

	tabInitiated = true;
}

function focusTab() {
	if (__DEBUG__)
		console.debug('Focus tab', { tabId });
	tabsProp().loadData();
	tabsProp().value.focusedTab = tabId;
	tabsProp().saveData();
}

function updateTabActivity() {
	checkTab();
	currentTab().lastActivity = Date.now();
	tabsProp().saveData();
}

function removeTab() {
	tabsProp().loadData();
	const idx = instance.tabs.findIndex(f => f.tabId === tabId);
	if (idx > -1) {
		instance.tabs.splice(idx, 1);
	}
	tabsProp().saveData();
}

function isInitiated() {
	return activeTabs()[0]?.tabId === tabId;
}

function isFocused() {
	tabsProp().loadData();
	return tabsProp().value.focusedTab === tabId;
}

Object.defineProperty(instance, 'tabs', {
	get: () => tabsProp().value?.tabs || [],
	set: (v) => tabsProp().value.tabs = v
})

Object.defineProperty(instance, 'isFocusedTab', {
	get: () => isFocused()
})

Object.defineProperty(instance, 'activeTabs', {
	get: () => activeTabs
})

Object.defineProperty(instance, 'currentTab', {
	get: () => currentTab()
})

Object.defineProperty(instance, 'isInitiatedTab', {
	get: () => isInitiated()
})

export default {
	instance,
	initTab
}

export {
	instance,
	initTab
}